import { store } from '../redux/store';

/**
 * Get current tenant venue parameters (organization_id and venue_id)
 * from Redux state for filtering data fetching operations.
 * 
 * @returns Object with organization_id and venue_id (one or both may be null)
 */
export function getCurrentTenantVenueParams(): {
  organization_id: string | null;
  venue_id: string | null;
} {
  const state = store.getState();
  const tenantVenue = state.venue.tenantVenue;
  
  // If tenantVenue is a venue object, return venue_id
  if (typeof tenantVenue === 'object' && tenantVenue.id) {
    return {
      organization_id: tenantVenue.organization_id || null,
      venue_id: tenantVenue.id
    };
  }
  
  // If tenantVenue is organization_id (string), return organization_id
  if (typeof tenantVenue === 'string' && tenantVenue !== 'all') {
    return {
      organization_id: tenantVenue,
      venue_id: null
    };
  }
  
  // Legacy "all" case - get organization_id from user
  const { user } = state.auth || {};
  if (user?.organization_id) {
    return {
      organization_id: user.organization_id,
      venue_id: null
    };
  }
  
  // Default: no filter
  return {
    organization_id: null,
    venue_id: null
  };
}

